import { computed } from 'vue';
import { useRoute, useRouter } from 'vue2-helpers/vue-router';

import RoutingComposable from '../models/routing/routing.composable.model';

const useRouting = (): RoutingComposable => {
  const route = useRoute();
  const router = useRouter();

  const isNextAvailable = computed(
    () => !!(metaParams.value && metaParams.value.next)
  );

  const isPreviousAvailable = computed(
    () => !!(metaParams.value && metaParams.value.previous)
  );

  const metaParams = computed(() => {
    return route.meta;
  });

  const path = computed(() => {
    return route.path;
  });

  const queryParams = computed(() => {
    return route.query;
  });

  const clearQueryParam = (param: string) => {
    const queryParams = { ...route.query };
    delete queryParams[param];

    router.replace({ query: queryParams });
  };

  const previous = () => {
    if (isPreviousAvailable.value) {
      router.push({
        path: metaParams?.value?.previous,
        query: queryParams?.value,
      });
    } else {
      console.warn('Previous route is not available!');
    }
  };

  return {
    isPreviousAvailable,
    isNextAvailable,
    metaParams,
    path,
    queryParams,
    clearQueryParam,
    previous,
  };
};

export { useRouting };
